export default {"src":"/_next/static/media/openEye.3046b133.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};